import { ActionType } from "../interfaces/api/actionType";

export const PostTalentCardClientEvent: ActionType = {
  FAILURE: "POST_TALENT_CARD_CLIENT_EVENT_FAILURE",
  REQUEST: "POST_TALENT_CARD_CLIENT_EVENT_REQUEST",
  SUCCESS: "POST_TALENT_CARD_CLIENT_EVENT_SUCCESS",
};
